import { Formik } from 'formik';
import React,{useState} from 'react'
import Modal from "react-modal";
import { XMarkIcon } from "@heroicons/react/20/solid";
import _ from "lodash";
const CommunicationModal = ({showCommunicationModal,setshowCommunicationModal}) => {
  const [file, setFile] = useState(null)
  const [image, setImage] = useState(null)
  const [commentArray, setcommentArray] = useState([])
  const [obj, setobj] = useState({
    file:"",
    msg:"",
    category:""
  })
    const customStyles = {
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          minHeight: "45vh",
          maxWidth: "800px",
          maxHeight: "75vh",
          overflowY: "scroll",
        },
      };

      
  const documentTypes = [
    { id: "Resident Card", name: "Resident Card" },
    { id: "Passport", name: "Passport" },
    { id: "Visa", name: "Visa" },
    { id: "National Card", name: "National Card" },
    { id: "Medical Record Number", name: "Medical Record Number" },
  ];

  
const onImageChange = (event) => {
  if (event.target.files && event.target.files[0]) {
    setImage(URL.createObjectURL(event.target.files[0]));
  }
 }

  const handleFileChange = event => {
    let input = event.target.files[0];
    setFile(input);
    console.log('The current file is '+file)
    if (!input) return;
    let data = new FormData();
    data.append("fileToUpload", input);
    setFile(data);
    // console.log('The current file is '+file)
  };
  // const handleChange(e)=>{

  // }

  const addData = (values) => {
    obj.file=image
    // obj.msg=
    let data = _.cloneDeep(values);
    commentArray.push(data)
    alert(commentArray.length)
    console.log(commentArray)

  }

  return (
    <div className=''>
        <Modal
             isOpen={true}
             // isOpen={showPreAuthResponseModal}
             onAfterOpen={showCommunicationModal}
             onRequestClose={() => setshowCommunicationModal(false)}
             style={customStyles}
             contentLabel="Example Modal"
        >
        <div className='flex justify-between items-center mb-2'>
          <h3 className='text-2xl text-cyan-800 font-bold'>Add Communication</h3>
          <XMarkIcon
              className="h-5 w-5 text-gray-900 hover:cursor-pointer "
              aria-hidden="true"
              onClick={() => setshowCommunicationModal(false)}
            />

        </div>
        <hr />

       
       <Formik
            initialValues={{
              file:"",
              comment:"",
              item:"",
              documentType:""
            
            }}
            validate={(values) => {
              const errors = {};
            }}
            onSubmit={(values, { setSubmitting }) => {
              // addData(values);
            }}
            className=" "
          >
              {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              /* and other goodies */
            }) => (
              <div className="-form  ">
                <form  action="#" method="POST">
                  <div className='flex items-center my-3'>
                    <div className='flex- w-[35%] flex items-center'>
                      <input type="file" placeholder="" onChange={onImageChange} />
                      <span className='mx-3'>OR</span>
                    </div>
                    <div className=' w-[65%]'>
                    <div className="sm:col-span-2 col-span-6">
                  
                      <input
                        placeholder="Enter your comment here"
                        type="text"
                        name="comment"
                        value={values.comment}
                        onChange={handleChange}
                     
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm w-100"
                      />
                    </div>

                    </div>
                  </div>
                  {/* second row */}
                  <div className='flex items-center gap-4'>
                  <div className="sm:col-span-2 col-span-6 required relative flex-1 gap-4">
                 
                      <select
                        id="documentType"
                        name="documentType"
                        onChange={handleChange}
                        value={values.documentType}
                        autoComplete="type-name"
                        required
                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      >
                        <option value="">Please Select</option>
                        {documentTypes.map((item) => {
                          return <option value={item.id}>{item.name}</option>;
                        })}
                      </select>
                      {errors.documentType && touched.documentType ? (
                        <div>{errors.documentType}</div>
                      ) : null}
                    </div>
                    <div>
                      <button className='p-2 px-4 bg-cyan-600 text-white'
                      onClick={addData}
                      >Add</button>
                    </div>
                  </div>
                  <hr />

                  <div className='mt-12 justify-between flex text-right '>
                    <h1></h1>
                  <div className=' flex gap-4  items-end'>
                      <button className='p-2 px-4 bg-cyan-600 text-white'>Cancel</button>
                      <button className='p-2 px-4 bg-cyan-600 text-white'>Add Communication</button>
                    </div>
                    

                  </div>
                 
                  
                </form>
               
              </div>
            )}

        </Formik>
        {
          commentArray?
            
              commentArray.map((item,index)=>{
                return(
                  <h1>jjj</h1>
                )

              }):""
            

          
        }
        

        </Modal>

    </div>
  )
}

export default CommunicationModal